import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { LoginService } from '@auth/services/login/login.service';

export const LoginGuard: CanActivateFn = async (route, state) => {
  const _token = inject(LoginService);
  const _service = inject(LoginService);

  const login = await _token.isValidLogin();
  _service.isValidLogin.set(login);
  if (login) {
    _service.volverInicio();
    return false;
  }
  return true;
};
